import { ViewType } from '../types'

interface CalendarViewSwitcherProps {
  activeView: ViewType
  onViewChange: (view: ViewType) => void
}

const CalendarViewSwitcher = ({ activeView, onViewChange }: CalendarViewSwitcherProps) => {
  const option = (label: string, view: ViewType) => {
    const active = activeView === view
    return (
      <button
        key={view}
        onClick={() => onViewChange(view)}
        role="radio"
        aria-checked={active}
        className={[
          'cursor-pointer rounded-md border-none px-4 py-[1.5px] !text-[16px] leading-none !font-semibold transition-all',
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500',
          active
            ? 'bg-[#E5533D] font-bold text-white shadow-[0_1px_2px_rgba(203,71,31,.3)]'
            : 'bg-transparent font-semibold text-[#6B7280]',
        ].join(' ')}
      >
        {label}
      </button>
    )
  }
  return (
    <div
      role="radiogroup"
      aria-label="Calendar view"
      className="schedule-v2-mulish inline-flex items-center gap-0.5 rounded-lg bg-[#F1F2F4] p-1"
    >
      {option('Day', 'timeGridDay')}
      {option('Week', 'timeGridWeek')}
      {option('Month', 'dayGridMonth')}
    </div>
  )
}
export default CalendarViewSwitcher
